import {
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import React from "react";
import moment from "moment";
import { GRAY, VARIANT, WHITE } from "../../../../constants/colors";
import { dateForListWithHours } from "../../../../constants/dataFormat";
import {
  FaCheck,
  FaClosedCaptioning,
  FaExclamation,
  FaTimes,
} from "react-icons/fa";

interface StatusTypes {
  [chave: string]: JSX.Element;
}

export default function ModalVendaDigitadaDetail({
  isOpen,
  setIsOpen,
  item,
}: any) {
  const finalRef = React.useRef(null);

  const statusTypes: StatusTypes = {
    Efetivado: <FaCheck />,
    Processando: <FaExclamation />,
    Pendente: <FaExclamation />,
    "Remessa Gerada": <FaExclamation />,
    "Não efetivado": <FaExclamation />,
    Cancelado: <FaTimes />,
  };

  const onClose = () => {
    setIsOpen(false);
  };

  console.log("item historico", item);

  return (
    <>
      <Modal
        finalFocusRef={finalRef}
        isOpen={isOpen}
        onClose={onClose}
        size={"5xl"}
      >
        <ModalOverlay backdropFilter="blur(10px)" />
        <ModalContent>
          <ModalHeader>
            <Flex w={"100%"} justifyContent={"center"}>
              <Text fontWeight={"bold"}>
                Detalhes da Solicitação de Transferência
              </Text>
            </Flex>
          </ModalHeader>
          {item && (
            <ModalBody>
              <Flex
                w={"100%"}
                alignItems={"flex-start"}
                minHeight={"250px"}
                height={"fit-content"}
                border={"2px solid #c4c4c4"}
                justifyContent={"space-evenly"}
                shadow={"md"}
                borderRadius={"6px"}
              >
                <TableContainer w={"100%"}>
                  <Table variant={"striped"} w={"100%"}>
                    <Thead>
                      <Tr>
                        <Th bgColor={VARIANT} color={WHITE}>
                          Data
                        </Th>
                        <Th bgColor={VARIANT} color={WHITE}>
                          Status
                        </Th>
                        <Th bgColor={VARIANT} color={WHITE}>
                          Observação
                        </Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {item.map((i: any) => {
                        return (
                          <Tr key={i.id}>
                            <Td fontSize={"14px"}>
                              {moment(i.data ? i.data : null).format(
                                dateForListWithHours
                              )}
                            </Td>
                            <Td fontSize={"14px"}>
                              {i.transacaoStatus ? (
                                statusTypes.hasOwnProperty(
                                  i.transacaoStatus.status
                                ) ? (
                                  <Flex
                                    alignItems={"center"}
                                    justifyContent="flex-start"
                                  >
                                    {statusTypes[i.transacaoStatus.status]}
                                    <Flex ml={4}>
                                      {i.transacaoStatus.status}
                                    </Flex>
                                  </Flex>
                                ) : (
                                  i.transacaoStatus.status
                                )
                              ) : (
                                ""
                              )}
                            </Td>
                            <Td
                              fontSize={"14px"}
                              cursor={"pointer"}
                              maxWidth={"300px"}
                              whiteSpace={"pre-wrap"}
                            >
                              {i.status ? i.status : ""}
                            </Td>
                          </Tr>
                        );
                      })}
                    </Tbody>
                  </Table>
                </TableContainer>
              </Flex>
            </ModalBody>
          )}
          <ModalFooter justifyContent={"space-evenly"}>
            <Button background={GRAY} color={"white"} mr={3} onClick={onClose}>
              Fechar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
